import { render, staticRenderFns } from "./DnsMessages.vue?vue&type=template&id=b0874784"
import script from "./DnsMessages.vue?vue&type=script&lang=ts"
export * from "./DnsMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports